export enum CaseStatusCategory {
  ALARM = "alarm",
  NEW = "new",
  INSPECTION = "inspection",
  WAITING = "waiting",
  REMEDIATION = "remediation",
  COMPLETE = "complete"
}

export interface CaseStatusTypes {
  id: number;
  name: string;
  completed: boolean;
  order: number;
  category: CaseStatusCategory;
}
